(function () {
	document.querySelectorAll(".split-image__container").forEach((el) => {
		const firstImage = el.querySelector("[data-split-foreground]");
		const secondImage = el.querySelector("[data-split-background]");
		const sliderButton = el.querySelector(".slider-button");
		const sliderLine = el.querySelector(".slider--line");

		el.querySelector("input[type='range']").addEventListener("input", handleSlideReveal);
		el.querySelector("input[type='range']").addEventListener("change", handleSlideReveal);

		function handleSlideReveal(event) {
			const sliderPos = event.target.value;
			el.style.setProperty("--width", sliderPos + "%");
		}
	});
})();
